import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function EmailListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailListing', {
		url: '/emails',
		controllerAs: 'vm',
		controller: EmailListingCtrl,
		templateUrl: '/ng/hub/Email/Listing/EmailListingCtrl.html?' + window.BUILD,
		permission: ['manage_email'],
		resolve: {
			$title: () => 'Email Reporting',
			$style: () => AssetManager.css('/ng/hub/Email/Listing/EmailListingCtrl.css'),
		},
	});
}

export class EmailListingCtrl {
	constructor(Api, $filter, $state) {
		'ngInject';
		this.$filter = $filter;
		this.$state = $state;
		this.Api = Api;
		this.dataTableLimit = 10;
		this.filters = {
			scheduled: {
				refresh: false,
				status: 'scheduled',
				type: 'manual',
			},
			draft: {
				refresh: false,
				status: 'draft',
				type: 'manual',
			},
			sent: {
				status: 'sent',
				type: 'manual',
			},
		};
		// any functions that are called because of the dataTable component
		/// need to have the correct this
		this.transformEmailItems = this.transformEmailItems.bind(this);
		this.sendToReport = this.sendToReport.bind(this);
		this.delete = this.delete.bind(this);
		this.edit = this.edit.bind(this);
	}

	edit(emailInRow) {
		window.location.href = `/posts/email_publish?orig_type=${emailInRow.status}&orig_id=${emailInRow.id}`;
	}

	delete(emailInRow) {
		if (window.confirm('Are you sure you want to delete this email?')) {
			this.Api.delete(`/emails/${emailInRow.id}`).then(() => {
				if (emailInRow.status == 'draft') {
					this.filters.draft.refresh = !this.filters.draft.refresh;
				} else if (emailInRow.status == 'scheduled') {
					this.filters.scheduled.refresh = !this.filters.scheduled.refresh;
				}
			});
		}
	}

	sendToReport(emailInRow) {
		window.location.href = this.$state.href('hub.loggedin.EmailReport', { id: emailInRow.id });
	}

	convertToStory(emailInRow) {
		window.location.href = `/stories/email_to_story/${emailInRow.id}`;
	}

	transformEmailItems(response) {
		var dateFormat = this.$filter('shDate');
		response.data = response.data.map(email => {
			email.created = dateFormat(email.created, 'long');
			if (email.send_on) {
				email.send_on = dateFormat(email.send_on, 'long');
			}
			if (email.date_sent) {
				email.date_sent = dateFormat(email.date_sent, 'long');
			}
			// this makes it so I can use `sender_email` as the column field
			/// name in dataTables because I can't do sender.email
			email.sender_email = email.user.email;
			email.sender_id = email.user.id;

			return email;
		});
		return response;
	}
}
